import { Patient } from 'api/account/patients.type';
import USStates from 'utils/US-States';

import { CareIsFor } from '../account-setup.types';

export interface Props {
  patientId: string | string[] | undefined;
  careIsFor: CareIsFor;
  onPatientUpdate?: (patient: Patient) => void;
  hideHospitalizationInfo?: boolean;
}

export interface FormProps {
  firstName: string;
  lastName: string;
  nickname: string;
  birthDate: Date;
  pronouns: 'she, her' | 'he, him' | 'they, them' | '';
  sex: string;
  gender: string;
  raceEthnicity: string[];
  hospitalizationFacility: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  zipCode: number;
  ayvaPharmacyUid: string;
  pharmacyNcpdpId: string;
}

export const sexOptions = [
  {
    label: 'Male',
    value: 'male',
  },
  {
    label: 'Female',
    value: 'female',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const genderOptions = [
  {
    label: 'Male',
    value: 'male',
  },
  {
    label: 'Female',
    value: 'female',
  },
  {
    label: 'Transgender',
    value: 'transgender',
  },
  {
    label: 'Non-binary',
    value: 'non_binary',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const ethnicityOptions = [
  { label: 'White', value: 'White' },
  { label: 'Black or African American', value: 'Black or African American' },
  {
    label: 'American Indian or Alaska Native',
    value: 'American Indian or Alaska Native',
  },
  { label: 'Chinese', value: 'Chinese' },
  { label: 'Vietnamese', value: 'Vietnamese' },
  { label: 'Native Hawaiian', value: 'Native Hawaiian' },
  { label: 'Filipino', value: 'Filipino' },
  { label: 'Korean', value: 'Korean' },
  { label: 'Japanese', value: 'Japanese' },
  { label: 'Chamorro', value: 'Chamorro' },
  { label: 'Other Asian', value: 'Other Asian' },
  { label: 'Other Pacific Islander', value: 'Other Pacific Islander' },
  {
    label: 'Some other race or multi-racial',
    value: 'Some other race or multi-racial',
  },
  {
    label: 'Mexican, Mexican Am., Chicano',
    value: 'Mexican, Mexican Am., Chicano',
  },
  { label: 'Puerto Rican', value: 'Puerto Rican' },
  { label: 'Cuban', value: 'Cuban' },
  {
    label: 'Another Hispanic, Latino, or Spanish origin',
    value: 'Another Hispanic, Latino, or Spanish origin',
  },
];

export const pronounOptions = [
  {
    label: 'she, her',
    value: 'she, her',
  },
  {
    label: 'he, him',
    value: 'he, him',
  },
  {
    label: 'they, them',
    value: 'they, them',
  },
];

export const StateOptions = USStates.map(s => ({
  label: s.name,
  value: s.name,
}));
